<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">委托方&nbsp;&nbsp;&nbsp;</div>
          <el-select
          size="mini" class="ipt-sty"
            @change="handleChangeCompany"
            v-model="page.tenantGuid"
            placeholder="请选择委托方"
            filterable
          >
            <el-option
              v-for="(item,index) in sendTenantList"
              :key="index"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            ></el-option> </el-select
        ></el-col>
        <el-col :span="6"
          ><div class="search-area-div">执行部门</div>
          <el-select size="mini" class="ipt-sty" v-model="page.organisationInfo" filterable placeholder="请选择执行部门">
            <el-option
              v-for="(item,index) in organisationList"
              :key="index"
              :label="item.organisationName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">执行时间</div>
          <el-date-picker
          size="mini" class="ipt-sty"
            v-model="timeRange"
            type="daterange"
            align="center"
            unlink-panels
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="截止时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore" :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6"
          ><div class="search-area-div">执行状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.timeState" filterable placeholder="请选择执行状态">
            <el-option v-for="item in timeStateList" :key="item" :label="item" :value="item"></el-option> </el-select
        ></el-col>
        <el-col :span="6">
          <div class="search-area-div">任务包状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.state" filterable placeholder="请选择任务包状态">
            <el-option v-for="item in stateList" :key="item" :label="item" :value="item"></el-option> </el-select
        ></el-col>
      </el-row>
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <el-table :data="tableData" :height="tableHeight" stripe border style="width: 100%" v-loading="tableLoading" @sort-change="sortChange">
        <el-table-column label="序号"  width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        
        <el-table-column fixed="left" prop="taskTitle" width="320" label="任务标题" show-overflow-tooltip header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.taskTitle || '-' }}</template>
        </el-table-column>
        <el-table-column prop="tenantName" sortable="custom" show-overflow-tooltip  width="240" label="委托方" header-align="center" align="left" >
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>
         <el-table-column prop="serviceTenantName" sortable="custom" show-overflow-tooltip  width="240" label="服务商" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.serviceTenantName||'-' }}</template>
        </el-table-column>
        <el-table-column prop="campaignsState" width="200" show-overflow-tooltip label="执行部门" header-align="center" align="left">
            <template slot-scope="scope">{{ getDepartmentName(scope.row.organisationInfo||scope.row.oldOrganisationInfo)}}</template>
        </el-table-column>

        <el-table-column prop="campaignsState" width="220" show-overflow-tooltip label="执行时间" header-align="center" align="left">
          <template slot-scope="scope"
            >{{ scope.row.startTime | getDate }} 至 {{
            scope.row.endTime | getDate
          }}</template
          >
        </el-table-column>
  
        <el-table-column prop="taskDetailCount" width="96" label="任务项目数" header-align="center" align="left">
          <template slot-scope="scope">共{{ scope.row.taskDetailCount }}项目</template>
        </el-table-column>
        <el-table-column
          prop="state"
          :render-header="renderHeader"
          width="150"
          label="任务包状态"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">{{ scope.row.state }}</template>
        </el-table-column>
        <el-table-column prop="timeState" width="96" label="业务执行状态" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.timeState }}</template>
        </el-table-column>
        <!-- <el-table-column prop="createUserName" width="70" label="完成状态" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.finishState }}</template>
        </el-table-column>
        <el-table-column prop="createUserName" width="100" label="成果上传状态" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.uploadState }}</template>
        </el-table-column>
        <el-table-column prop="createUserName" width="70" label="结算状态" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.payState }}</template>
        </el-table-column> -->
        <el-table-column prop="taskNo" width="120" label="任务包编号" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.taskNo }}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="190px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
              <a
              class="txt-color"
              v-if="scope.row.state != '待发布' && scope.row.state != '已撤回'"
              @click="toSeeProgress(scope.row)"
              >任务进展
            </a>
            <a
              class="txt-color"
              v-if="scope.row.state == '待受理'"
              @click="toDeal(scope.row)"
              >去受理</a
            >
            <a
              class="txt-color"
              v-if="isShowCancelBtn(scope.row)"
              @click="setCancel(scope.row)"
              >设为失效</a
            >
            <a
              class="txt-color"
              v-if="
                scope.row.state == '已派发' ||
                scope.row.state == '已结束' ||
                scope.row.state == '待结算' ||
                scope.row.state == '待考核' ||
                scope.row.state == '已完结' ||
                (scope.row.uploadState == '已上传' && scope.row.timeState == '已结束') ||
                (scope.row.uploadState == '未上传' && scope.row.timeState == '已结束')
              "
              @click="toDeal(scope.row)"
              >任务详情
            </a>
           
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50,100,200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
let userinfo = JSON.parse(localStorage.userInfo);
export default {
  data() {
    return {
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 213,
      contentMainHeight: window.innerHeight - 200,
      tableLoading: false,
      textTitle: '配置任务包',
      stateList: ['待受理'],
      timeStateList: ['未开始', '进行中', '已结束'],
      tenantList: [],
      organisationList: [],
      timeRange: '',
      page: {
        taskBelongCategory:1,
        serviceTenantGuid:localStorage.guid,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        organisationInfo: '',
        startTime: '',
        endTime: '',
        state: '待受理',
        timeState: '',
        orderColumn:'',
        isService:'Y',
        createUserName: userinfo.staffName,
      },
      right: 'right',
      tableData: [],
      sendTenantList:[],
    };
  },
  created() {
    // this.getTenantList();
    this.getSendTenantList();
    this.getList();
  },
  activated() {
    this.getList();
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 260;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 213;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  methods: {
    getDepartmentName(list) {
      if (typeof list == 'string') {
        list = JSON.parse(list);
      }
      let personArr = [];
      let personTip = '';
      let departmentArr = [];
      let departmentTip = '';
      let personNum = 0;
      let departmentNum = 0;
      if (list && list.length > 0) {
        list.forEach(i => {
          if (i.objectType == '人员') {
            personArr.push(i.organisationName || i.name);
            personNum = personNum + 1;
          } else {
            departmentNum = departmentNum + 1;
            departmentArr.push(i.organisationName || i.name);
          }
        });
      }
      personTip =
        personArr.length > 2
          ? personArr.splice(0, 2).join('、') + `等${personNum}个人`
          : personArr.splice(0, 2).join('、');
      console.log(personArr);
      departmentTip =
        departmentArr.length > 2
          ? departmentArr.splice(0, 2).join('、') + `等${departmentNum}个部门`
          : departmentArr.splice(0, 2).join('、');
      return departmentTip + (departmentTip && personTip ? '，' : '') + personTip;
    },
    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    isShowCancelBtn(row){
      let userInfo=JSON.parse(localStorage.userInfo)
      if(row.createUserId==userInfo.userGuid){
        return true
      }
      return false
    },
    search() {
      let self = this;
      self.tableLoading = true;
      self.page.pageIndex = 1;
      if (self.timeRange.length != 0) {
        self.page.startTime = self.timeRange[0] + ' ' + '00:00:00';
        self.page.endTime = self.timeRange[1] + ' ' + '23:59:59';
      }
      var req = JSON.parse(JSON.stringify(this.page));
      req.state = req.state ? [req.state] : ['待受理'];
      let userInfo=JSON.parse(localStorage.userInfo)
      req.userId = userInfo.userGuid;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getList() {
      let self = this;
      var req = JSON.parse(JSON.stringify(this.page));
      req.state = req.state ? [req.state] : ['待受理'];
      let userInfo=JSON.parse(localStorage.userInfo)
      req.userId = userInfo.userGuid;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    sortChange(column) {
      console.log(column)
      if (column.prop == "tenantName"&&column.order) {
        this.page.orderColumn = 'tenant_name'
      } else if (column.prop == "serviceTenantName"&&column.order){
        this.page.orderColumn = 'service_tenant_name'
      }else{
        this.page.orderColumn = '';
      }
      this.getList()// 查询列表方法
    },
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['010201','0101'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleChangeCompany(v) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
        sendTenantGuid:localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        }
      });
    },
    addVersion() {
      this.$router.push('/taskDeliverAdd?productGuid='+this.$route.query.productGuid);
    },
    delVersion(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/delete?guid=${guid}`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        organisationInfo: '',
        startTime: '',
        endTime: '',
        state: '待受理',
        timeState: '',
        serviceTenantGuid:localStorage.guid,
        orderColumn:'',
        isService:'Y',
        taskBelongCategory:1
      };
      this.organisationList = [];
      this.timeRange = '';
      this.getList();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    reBackVersion(detail, type) {
      if (type == 0) {
        //撤回
        this.tableLoading = true;
        var self = this;
        var req = {
          guid: detail.guid,
          state: '已撤回',
          currentTenantGuid:localStorage.guid
        };
        self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/edit`, req).then((res) => {
          this.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('撤回成功');
            self.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      } else {
        //重新提交
        this.$router.push('/taskDeliverAdd?guid=' + detail.guid + '&is_edit=1&productGuid='+this.$route.query.productGuid);
      }
    },
    setCancel(detail) {
      var self = this;
      self
        .$confirm('设为失效后，业务员将看不到此任务，确定此操作嘛？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          this.tableLoading = true;
          var self = this;
          var req = {
            guid: detail.guid,
            state: '已失效',
            currentTenantGuid:localStorage.guid
          };
          self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/edit`, req).then((res) => {
            this.tableLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('设置成功！');
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    see(detail) {
      this.$router.push('/taskDeliverAdd?guid=' + detail.guid+'&productGuid='+this.$route.query.productGuid); //查看
    },
    toDeal(detail) {
      this.$router.push('/taskDeliverModify?guid=' + detail.guid+'&productGuid='+this.$route.query.productGuid); //去处理
    },
    toUpload() {
      this.$router.push('/operationReport?productGuid='+this.$route.query.productGuid); //查看
    },
    toPay() {
      this.$router.push('/freeList?productGuid='+this.$route.query.productGuid+'&productGuid='+this.$route.query.productGuid);
    },
    toSeeProgress(detail){
        this.$router.push('/taskProgress?guid=' + detail.guid+'&productGuid='+this.$route.query.productGuid); //去处理
    },
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
                '待受理：需要代运营人员在运营平台进行受理并分解任务包；',
                
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
  },
};
</script> 
<style scoped>
.txt-color {
  word-break: keep-all;
}
a.txt-color + a.txt-color::before {
  content: '|';
  display: inline-block;
  margin: 0 4px;
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.search-area-div{
  width:72px;
}
.el-col-6{
  display: flex;
}
 .el-col-8{
  display: flex;
}
</style>